export const SOURCE_METADATA = [
  "type",
  "reliability",
  "misinfoSusceptibility",
  "language",
  "countryOfOrigin",
  "countryOfFocus",
];

const formatSourceMetadata = (items) =>
  items.map(({ text, value = text.toLowerCase() }) => ({
    text,
    value,
    count: 0,
    displayText: text,
  }));

export const SOURCE_METADATA_TYPE = formatSourceMetadata([
  { text: "Academic/Think Tank", value: "academic/think tank" },
  { text: "Activist/Extremist", value: "activist/extremist" },
  { text: "Forum" },
  { text: "Humanitarian" },
  { text: "Journalistic" },
  { text: "Labor Union", value: "labor union" },
  { text: "Official/Government", value: "official/government" },
  { text: "Other" },
  { text: "Political" },
  { text: "State-Controlled Media", value: "state-controlled media" },
]);

export const SOURCE_METADATA_RELIABILITY = formatSourceMetadata([
  { text: "High" },
  { text: "Medium" },
  { text: "Low" },
  { text: "Unrated" },
]);
